import type { IWorkJourneyManagementUser } from '@src/models/interfaces/workJourneyManagement.interface';

/**
 * Stable key for cover / report-absence picker rows.
 * Prefer attendanceRecordId so the same employee on two journeys stays distinct;
 * fall back to employee id for management flows that only pass a user.
 */
export const getCoverPickerRowKey = (user: IWorkJourneyManagementUser): string =>
  user.attendanceRecordId ?? user.id;
